export default __webpack_public_path__ + "static/media/3.57505a0a.jpg";